// This object serves as a singleton to store config options

var extend = require('extend');

var config = module.exports = {
  load: function (newOpts) {
    extend(config, newOpts);
    return config;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/ripple-lib/src/js/ripple/config.js
// module id = 376
// module chunks = 0